module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"hls.js","commonjs2":"hls.js","amd":"hls.js","root":"Hls"}
// module id = 1
// module chunks = 0


// WEBPACK FOOTER //
// hls/external {"commonjs":"hls.js","commonjs2":"hls.js","amd":"hls.js","root":"Hls"}